import { areAddressesEqual, isSupportedAddress } from '@cowprotocol/cow-sdk'
import { NativeCurrency, Token } from '@cowprotocol/currency'
import { TokenInfo } from '@cowprotocol/types'

const alwaysTrue = (): boolean => true

/** Creates a filter function that filters tokens that do not match the query. */
export function getTokenSearchFilter<T extends Token | TokenInfo>(
  query: string,
): (token: T | NativeCurrency) => boolean {
  if (isSupportedAddress(query)) {
    return (t: T | NativeCurrency) => 'address' in t && areAddressesEqual(query, t.address)
  }

  const queryParts = query
    .toLowerCase()
    .split(/\s+/)
    .filter((s) => s.length > 0)

  if (queryParts.length === 0) return alwaysTrue

  const match = (s: string): boolean => {
    const parts = s
      .toLowerCase()
      .split(/\s+/)
      .filter((s) => s.length > 0)

    return queryParts.every((p) => p.length === 0 || parts.some((sp) => sp.startsWith(p) || sp.endsWith(p)))
  }

  return ({ name, symbol }: T | NativeCurrency): boolean => {
    // Filter out from token names the bridge info to not pollute the results with garbage entries
    const filteredName = name?.replace(/\s*(on\s(gnosis|xdai)|from\s(mainnet|ethereum)).*$/i, '')

    return Boolean((symbol && match(symbol)) || (filteredName && match(filteredName)))
  }
}
